<ion-content [ngSwitch]="loginType">
  <app-username-password *ngSwitchCase="sagaUsernamePassword"></app-username-password>
  <app-trusted-user *ngSwitchCase="trustedUser"></app-trusted-user>
  <app-trusted-user *ngSwitchCase="trustedUserAndRole"></app-trusted-user>
</ion-content>
